import React, {useEffect} from 'react'
import tw, { styled } from 'twin.macro'
import {AnimatePresence} from 'framer-motion'
import {atom, useAtom} from 'jotai'
import {useUpdateAtom} from 'jotai/utils'

import { useMCPCallbackParams } from '@/hooks/useMCPCallbackParams'
import {AlertModal} from '@/components/AlertModal'

import {injectModalVisibleAtom} from './components/Spirits/atoms/injectModalVisibleAtom'
import Spirits from './components/Spirits'
import Communication from './components/Communication'
import Tours from './Tours'

const errorMessageAtom = atom<string | null>(null)

const useMCPCallback = () => {
  const params = useMCPCallbackParams()
  const setError = useUpdateAtom(errorMessageAtom)
  useEffect(() => {
    if (params && params.succeed) {
      // gtag('event', 'claim/identity/mcp_succeed')
    }
    if (params && !params.succeed && params.code) {
      // gtag('event', 'claim/identity/mcp_failed', {
      //   code: params.code,
      // })
      if (params.code !== 'null') {
        // show alert for MCP callback error.
        setError(`My Crypto Profile authorization error. [${params.code}]`)
      }
      // Sentry.captureMessage('MCP Authorization failed', {
      //   tags: {
      //     MCPErrCode: params.code,
      //   },
      // })
    } else {
      setError(null)
    }
  }, [params, setError])
}

const CallbackAlert = () => {
  const [error, setError] = useAtom(errorMessageAtom)
  const setModalVisible = useUpdateAtom(injectModalVisibleAtom)
  return (
    <AlertModal
      onClose={() => {
        window.history.replaceState({}, '', window.location.href.split('?')[0])
        setError(null)
        requestAnimationFrame(() => setModalVisible(true))
      }}
      content={error}
      visible={!!error}
      title="Error"
      buttonName="Try Again"
    />
  )
}

// markup
export default function ClaimPage() {
  useMCPCallback()
  return (
    <main>
      <div tw="relative">
        <AnimatePresence mode="wait">
          <Spirits />
        </AnimatePresence>
        <Communication />
        <Tours />
      </div>
      <CallbackAlert />
    </main>
  )
}
